// extracted by css-extract-rspack-plugin
export default {"Mark":"bXnAj"};